import Vue from 'vue'
import Vuex from 'vuex'
import YunJi from '@/common/js/YunJi'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    stateHeight: '20px',
    headerHeight: '64px',
    appCont: YunJi.getUrlParams('appCont') || 0,
    shopId: YunJi.getUrlParams('shopId') || '',
    clientWidth: document.body.clientWidth || window.screen.width || window.screen.availWidth,
    isApp: YunJi.isApp(),
    isShowPopPage: false,
    isShowBottomPage: false,
    isShowGoodPoster: false,
    bottomShareData: {
      diffPerson: '',
      income: ''
    },
    componentId: null,
    luckType: 0,
    luckyParams: null,
    sharePopType: 0,
    isShowCloseBtn: true,
    wxShareData: null,
    groupData: {}
  },
  getters: {
    // 埋点数据   
    pointData: (state) => {
      const params = {
        page_id: state.appCont == 0 ? '00126' : '10249',
        content_id: state.groupData.groupbuyId,
        item_id: state.groupData.itemId,
        Assemblechannel: YunJi.getUrlParams('Assemblechannel') || '',
        content_type: state.groupData.openTyper == 1 ? '0-团长中间页' : '1-团员中间页'
      }
      return params
    },
    userParam: (state) => { // 拼团活动各种文案case 
      const userInfo = {
        btnType: 0, // 0:默认邀请好友 1:查看更多拼团商品 2:抽奖     
        titleTetxt: '拼团成功',
        titleType: 'success',
        wbText: null,
        isShowIcon: true
      }
      // 中间文案部分
      if (state.groupData.activityStatus == 1 && state.groupData.groupStatus == 1) { // 拼团活动未结束
        if (state.groupData.bizStatus == 0) {
          const incomes = state.groupData.income // 可省多少          
          const diffPerson = state.groupData.groupbuyPersonNum - state.groupData.singles.length // 差几人成团          
          if (diffPerson > 0) {
            userInfo.wbText = `差<sapn style="color: #EE2532;font-size: 0.36rem;font-weight bold;margin-bottom 0.3rem">${diffPerson}</sapn>人拼团成功，
            可<sapn style="color: #EE2532;font-size: 0.36rem;font-weight bold;margin-bottom 0.3rem">省￥${incomes}</sapn>`
          }
        } else if (state.groupData.draws) { // 抽奖团
          if (state.groupData.draws.hasGetDraws || state.groupData.bizStatus == 2) { // 达到抽奖资格 或者是拼团失败       
            userInfo.wbText = null
          } else {
            const num = state.groupData.draws.getDrawsPerson - state.groupData.playedNum
            userInfo.wbText = `再邀请<sapn style="color: #EE2532;font-size: 0.36rem;font-weight bold;margin-bottom 0.3rem">${num}</sapn>人参团，即${state.groupData.draws.drawType === 2 ? `可得${state.groupData.draws.drawsName}` : '可领奖'}`
          }
        }
        // 对用户身份进行判断
        if (state.groupData.draws && state.groupData.draws.drawType === 2 && state.groupData.openTyper !== 1) { // 团长团非团长本人用户逻辑 
          userInfo.wbText = null
        }
      } else {
        userInfo.wbText = null
      }
      // 头部文案状态      
      if (state.groupData.bizStatus == 2) { // 拼团失败
        userInfo.titleType = 'fail'
        userInfo.titleTetxt = '拼团失败'
      } else {
        userInfo.titleType = 'success'
        if (state.groupData.bizStatus == 1) {
          userInfo.titleTetxt = '拼团成功'
        } else if (state.groupData.openTyper == 1) {
          userInfo.titleTetxt = '开团成功'
        } else {
          userInfo.titleTetxt = '参团成功'
        }
      }
      // 按钮状态部分
      // 活动30天失效不能抽奖 有抽奖活动，且 是否可以抽奖
      if (state.groupData.activityStatus != 3 && state.groupData.draws && state.groupData.draws.drawType === 2 && state.groupData.openTyper === 1 && state.groupData.draws.hasPlayDraws) {
        userInfo.btnText = '点我领奖'
        userInfo.isShowIcon = false
        userInfo.btnType = 2
      } else if (state.groupData.activityStatus != 3 && state.groupData.draws && state.groupData.draws.drawType === 1 && state.groupData.draws.hasPlayDraws) {
        userInfo.btnText = '点我领奖'
        userInfo.isShowIcon = false
        userInfo.btnType = 2
      } else if (state.groupData.draws && state.groupData.draws.drawType === 2 && state.groupData.openTyper !== 1) { // 团长团非团长本人用户逻辑
        userInfo.btnText = '看看其他拼团商品'
        userInfo.btnType = 1
        userInfo.isShowIcon = false
      } else if (state.groupData.activityStatus != 1 || state.groupData.bizStatus != 0 || state.groupData.groupStatus == 2) { // 1.拼团失败或者是成功 2.活动结束
        let isShowGoods = true
        if (state.groupData.draws && state.groupData.activityStatus == 1 && state.groupData.groupStatus == 1) { // 活动团 未结束
          if (!state.groupData.draws.hasGetDraws && state.groupData.bizStatus == 1) { // 未达到抽奖门槛且拼团成团
            isShowGoods = false
          }
        }
        if (isShowGoods) {
          userInfo.btnText = '看看其他拼团商品'
          userInfo.btnType = 1
          userInfo.isShowIcon = false
        } else {
          userInfo.btnText = state.groupData.bizStatus == 1 ? '邀请好友参团' : '邀请好友拼团'
          userInfo.isShowIcon = true
          userInfo.btnType = 0
        }
      } else {
        userInfo.btnText = '邀请好友拼团'
        userInfo.isShowIcon = true
        userInfo.btnType = 0
      }
      // eslint-disable-next-line consistent-return
      return userInfo
    }
  },
  mutations: {
    SET_STATE_HEIGHT(state, item) { // 设置状态栏高度  
      state.stateHeight = item
    },
    SET_HEADER_HEIGHT(state, item) { // 设置页面padding值
      state.headerHeight = item
    },
    SET_GROUP_DATA(state, item) { // 设置页面详情参数
      state.groupData = item || {}
    },
    SET_SHOW_POP_PAGE(state, item) { // 设置弹窗 显示 与关闭
      state.isShowPopPage = item
    },
    SET_SHOW_BOTTOM_PAGE(state, item) { // 设置底部弹窗 显示 与关闭
      state.isShowBottomPage = item
    },

    SET_BOTTOM_SHARE_DATA(state, item) { // 设置底部弹窗数据
      state.bottomShareData = item
    },
    SET_SHOW_GOOD_POSTER(state, item) { // 设置二维码弹框
      state.isShowGoodPoster = item
    },
    SET_COMPONENT_ID(state, item) { // 设置弹窗组件id
      state.componentId = item
    },
    SET_LUCK_TYPE(state, item) { // 设置抽奖弹窗属性 0 抽奖， 1 抽奖结果， 2 查询抽奖结果
      state.luckType = item
    },
    SET_SHARE_POP_TYPE(state, item) { // 设置分享弹窗类型 0 支付成功弹窗，1 分享成功弹窗，2 拼团成功弹窗
      state.sharePopType = item
    },
    SET_WX_SHARE_DATA(state, item) { // 设置微信分享数据
      state.wxShareData = item
    },
    SET_CLOSE_BTN(state, item) { // 设置弹窗是否显示 关闭按钮
      state.isShowCloseBtn = item
    },
    SET_LUCKY_PARAMS(state, item) { // 设置抽检结果数据
      state.luckyParams = item
    }
  },
  actions: {
  },
  modules: {
  }
})
